"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filtrerEventerTilHelhetligMåling = filtrerEventerTilHelhetligMåling;
exports.getWindowWithMatomo = getWindowWithMatomo;
exports.konfigurerMatomo = konfigurerMatomo;
exports.leggTilInstruksjon = void 0;
var _constants = require("./constants");
var _clickListener = require("./listeners/clickListener");
var _utils = require("./utils");
function konfigurerMatomo(siteID, sporTilHelhetligMåling, erSamtykkeGitt, miljø) {
  const windowWithMatomo = getWindowWithMatomo();
  if (!windowWithMatomo) return;
  const {
    trackerURL,
    scriptURL
  } = (0, _utils.getMatomoURLs)(miljø);
  if (!windowWithMatomo.__skeMatomoKonfigurert) {
    leggTilInstruksjon('enableLinkTracking', []);
    leggTilInstruksjon('HeatmapSessionRecording::disable');
    leggTilInstruksjon('setTrackerUrl', trackerURL);
    leggTilInstruksjon('setSiteId', siteID);
    if (sporTilHelhetligMåling) {
      leggTilInstruksjon('addTracker', trackerURL, _constants.SKATTEETATEN_SITE_ID);
      leggTilInstruksjon('setCustomRequestProcessing', filtrerEventerTilHelhetligMåling);
    }
    (0, _clickListener.addClickListener)(); // Legger til global matomo måling ved klikk på enten "a" eller "button"
    windowWithMatomo.__skeMatomoKonfigurert = true; // Setter et flagg på window objektet for å indikere til andre MF'er at vi er initialisert.
  }
  if (erSamtykkeGitt || erStatistikkCookieSamtykkeGitt()) {
    initialiserMatomoScript(scriptURL, windowWithMatomo);
  }
  return {
    opprettet: true,
    leggTilInstruksjon
  };
}
const godkjentSamtykke = ['nodvendigeOgWebanalyseInformasjonskapsler', 'anbefalteInformasjonskapsler'];
function erStatistikkCookieSamtykkeGitt() {
  const statistikkCookie = (0, _utils.getCookieVerdi)('skatteetaten.statistikk') || '';
  return godkjentSamtykke.includes(statistikkCookie);
}
function initialiserMatomoScript(scriptURL, windowWithMatomo) {
  if (windowWithMatomo?.Piwik?.initialized === true) {
    return;
  }
  const matomoScript = document.createElement('script');
  matomoScript.type = 'text/javascript';
  matomoScript.async = true;
  matomoScript.defer = true;
  matomoScript.src = scriptURL;
  matomoScript.setAttribute('data-testid', 'matomo-script');
  document.body.appendChild(matomoScript);
}

/**
 * Legger til en instruksjon på den globale matomo objektet.
 * Matomo spesifiserer på sine sider at for å jobbe med matomo apiet,
 * benyttes denne syntaksen:
 * `_paq.push([ 'API_method_name', parameter_list ]);`
 *
 * Ved å bruke denne funksjonen kan vi heller skrive:
 *  `leggTilInstruksjon('API_method_name', 'Menu', 'Freedom')`
 *  `leggTilInstruksjon('trackEvent', category, action, name, value, {dimension1: 'DimensionValue'})`
 */
const leggTilInstruksjon = (identifier, ...instruksjoner) => {
  const windowWithMatomo = getWindowWithMatomo();
  if (!windowWithMatomo) return;
  if (instruksjoner.length === 0) {
    return windowWithMatomo._paq.push([identifier]);
  }
  windowWithMatomo._paq.push([identifier, ...instruksjoner]);
};

/**
 * Filtrerer Matomo eventer slik at bare sidevisninger og lenkeklikk sendes til Helhetlig Måling.
 * Dette er for å begrense dupliseringen av eventer til de vi faktisk trenger, og dermed forbedre ytelsen.
 *
 * Eventer til andre site id-er blir ikke filtrert.
 *
 * Eksempelbruk: _paq.push(["setCustomRequestProcessing", filtrerEventerTilHelhetligMåling])
 */
exports.leggTilInstruksjon = leggTilInstruksjon;
function filtrerEventerTilHelhetligMåling(request) {
  const params = new URLSearchParams(request);
  const siteId = params.get('idsite');
  // Hvis actionName er definert er eventet av typen sidevisning
  const actionName = params.get('action_name');
  const link = params.get('link');
  if (siteId !== _constants.SKATTEETATEN_SITE_ID.toString()) {
    return request;
  }
  if (actionName || link) {
    return request;
  }
  return false;
}
function getWindowWithMatomo() {
  if (typeof window === 'undefined') return undefined;
  const windowWithMatomo = window;
  windowWithMatomo._paq = windowWithMatomo._paq || [];
  return windowWithMatomo;
}